import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './common.css';
import "antd-mobile/dist/antd-mobile.css";
import "video-react/dist/video-react.css";
import App from './AppGJ';
if (navigator.userAgent.indexOf("amcfmapp")>-1) {
window.isLess47=!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)||navigator.userAgent.indexOf('Chrome')==-1?true:navigator.userAgent.match(/Chrome\/([\d.]+)/)[1]>='47';
}else{
window.isLess47=true
}
window.winWidth = document.documentElement.clientWidth;
window.winHeight = document.documentElement.clientHeight;
// window.navigator.userAgent = navigator.userAgent.toLowerCase();
window.funSplit=function(str){
  if (str) {
    if(str.includes("暂不支持该行扣款")) {
      const _str = str.replace(/暂不支持该行扣款/, "该银行暂不支持扣款，建议使用活期通支付");
      return _str.split("|");
    }
    return str.split("|");
  }else{
    return ['',''];
  }
}
window.clearLocalStorage=function(){
	window.localStorage.removeItem('currentUserInfo');
  window.localStorage.removeItem('loginInfo-longToken');
  window.localStorage.removeItem('loginInfo-shortToken');
  window.localStorage.removeItem('loginState');
  window.localStorage.removeItem('tokenTimeLong');
  window.localStorage.removeItem('tokenTimeshort');
  window.localStorage.removeItem('amcuid2');
}
ReactDOM.render(<App />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js